import React, { FunctionComponent } from 'react'
import MatchStatus, { BasicMatchStatusProps } from '../../../../Match/Status'

export type DartsMatchStatusProps = BasicMatchStatusProps & {
    /** image url of the competition, will be displayed in the headline */
    competitionImageUrl?: string
    /** alternative description of the competition logo */
    competitionImageAlt?: string
}

const DartsMatchStatus: FunctionComponent<DartsMatchStatusProps> = ({
    competitionImageUrl,
    competitionImageAlt,
    ...props
}) => {
    return (
        <MatchStatus
            logoUrl={competitionImageUrl}
            logoAlt={competitionImageAlt}
            backgroundColor="onyx-2"
            competitorType="PLAYER"
            {...props}
        />
    )
}
export default DartsMatchStatus
